import { MODEL_VIEW } from 'src/store/ActionTypes';

export const fetchModel = (id) => ({
  type: MODEL_VIEW.FETCH_MODEL,
  payload: id,
});

export const remediateModel = (id, treatment, lowerBound, upperBound) => ({
  type: MODEL_VIEW.REMEDIATE_MODEL,
  payload: {
    modelId: id,
    treatment,
    lowerBound,
    upperBound,
  },
});

export const setChart = (chart) => ({
  type: MODEL_VIEW.SET_CHART,
  payload: chart,
});

/**
 * setQuantileIdx - set the index in availableQuantiles we're viewing
 * @param {number} index
 * @return {{type: string, payload: number}}
 */
export const setQuantileIdx = (index) => ({
  type: MODEL_VIEW.SET_QUANTILE_IDX,
  payload: index,
});

/**
 * setAvailableQuantiles - update the list of available quantiles to view
 * @param {{current: number[], premiums: number[]|undefined, persons: number[]|undefined}} availableQuantiles
 * @return {{type: string, payload: {current: number[], premiums: number[]|undefined, persons: number[]|undefined}}}
 */
export const setAvailableQuantiles = (availableQuantiles) => ({
  type: MODEL_VIEW.SET_QUANTILES,
  payload: availableQuantiles,
});

/**
 * setQuantiles - set the number of quantiles viewed and processed by charts
 * @param {number} quantiles
 * @return {{payload: number, type: string}}
 */
export const setQuantiles = (quantiles) => ({
  type: MODEL_VIEW.SET_QUANTILES,
  payload: quantiles,
});

/**
 * setEqualType - set the equalType of actuarial lift charts
 * @param {string} equalType
 * @return {{payload: string, type: string}}
 */
export const setEqualType = (equalType) => ({
  type: MODEL_VIEW.SET_EQUAL_TYPE,
  payload: equalType,
});

export const fetchInputDistDownloadUrl = (entityId, entityType) => ({
  type: MODEL_VIEW.FETCH_INPUT_DIST_DOWNLOAD_URL,
  payload: { entityId, entityType },
});

export const fetchDownloadUrl = (id) => ({
  type: MODEL_VIEW.FETCH_DOWNLOAD_URL,
  payload: id,
});

export const fetchLiftChartDownloadUrl = (entityId, entityType) => ({
  type: MODEL_VIEW.FETCH_LIFT_CHART_DOWNLOAD_URL,
  payload: { entityId, entityType },
});

export const setGradient = (gradient) => ({
  type: MODEL_VIEW.SET_GRADIENT,
  payload: gradient,
});

export const initRoiCalculatorState = (payload) => ({
  type: MODEL_VIEW.INIT_ROI_CALCULATOR_STATE,
  payload,
});

export const updateRoiCalculatorState = (key, value) => ({
  type: MODEL_VIEW.UPDATE_ROI_CALCULATOR_STATE,
  payload: {
    key,
    value,
  },
});

export const resetRoiCalculatorStateField = (key) => ({
  type: MODEL_VIEW.RESET_ROI_CALCULATOR_STATE_FIELD,
  payload: key,
});

export const saveRoiCalculatorState = (payload) => ({
  type: MODEL_VIEW.SAVE_ROI_CALCULATOR_STATE,
  payload,
});

export const exportRoiCalculator = () => ({
  type: MODEL_VIEW.EXPORT_ROI_CALCULATOR,
});

export const setReadyExport = (bool) => ({
  type: MODEL_VIEW.EXPORT_ROI_CALCULATOR_READY,
  payload: bool,
});

/**
 * unset - Reset a redux state key to its default
 * @param key {string} the state key to reset
 * @returns {{payload: string, type: string}}
 */
export const unset = (key) => ({
  type: MODEL_VIEW.UNSET,
  payload: key,
});

export const resetPage = () => ({
  type: MODEL_VIEW.RESET_PAGE,
});
